require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp, usePage } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import mitt from 'mitt';

window.emitter = mitt();

const appName = window.app_name = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
createInertiaApp({
  title: (title) => `${title} | ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
      return createApp({ render: () => h(app, props) })
      .use(plugin)
      .mixin({ methods: { route, asset(url){ return appUrl + url; }} })
      .mount(el);
          },
        });

const appUrl = window.app_url = route('index');

InertiaProgress.init({ color: '#e09a3d' });


// header on Scroll
window.addEventListener('scroll', (e) => {
    if(window.pageYOffset > 100) {
      document.querySelector('.header').classList.add('fixed-bar')    
    }else {
      document.querySelector('.header').classList.remove('fixed-bar')   
    }
});

// Side Nav
setTimeout(() => {
  document.getElementById("filter-collapse-btn")?.addEventListener("click",function(){
    document.getElementById('filter-wrapper').classList.add('show')
  })
  document.getElementById("close-filter")?.addEventListener("click",function(){
    document.getElementById('filter-wrapper').classList.remove('show')
  })

  if(window.innerWidth < 512){
    document.querySelector('.pagination')?.classList.add('pagination-sm')
  }
}, 1000);


window.addEventListener('scroll', (e) => {
  if(window.pageYOffset > 500) {
    document.querySelector('#back-to-top')?.classList.remove('d-none')   
    document.querySelector('#filters-sidebar')?.classList.remove('d-none')   
  }else {
    document.querySelector('#back-to-top')?.classList.add('d-none')    
    document.querySelector('#filters-sidebar')?.classList.add('d-none')    
  }
});